import { Checkbox } from '@mui/material';
import DefaultMerchandise from '@assets/default-merchandise.svg';
import classes from '../index.module.css';

export default function ChooseItemDamage({
  item, selectedInfo, handleCheckboxChange, onClick,
}) {
  const {
    lineItemId, imageUrl, itemTitle, variantTitle, sku, hasDiscount, actualPrice, price, maxQuantity, quantity,
  } = item;
  const {
    quantity: selectedQuantity, files1 = [], files2 = [], files3 = [], comment,
  } = selectedInfo;
  const files = [...files1, ...files2, ...files3].map((file) => file.name);

  return (
    <section className={`${classes.merchandise}`} key={lineItemId}>
      <section className={classes.merchandise_content}>
        <section className={classes.item_info}>
          <Checkbox
            id="responsive_line_item_checkbox"
            color="input"
            onChange={(e) => handleCheckboxChange(e, item)}
            disabled={!maxQuantity}
            value={lineItemId}
            checked={selectedInfo.lineItemId === lineItemId}
          />
          <img
            src={imageUrl || DefaultMerchandise}
            className={classes.item_img}
            alt=""
            onError={(e) => {
              const img = e.currentTarget;
              img.src = DefaultMerchandise;
              img.οnerrοr = null;
            }}
          />
          <section className={classes.info_block}>
            {itemTitle ? <section className={classes.title}>{itemTitle}</section> : null}
            {variantTitle ? <section className={classes.sub_title}>{variantTitle}</section> : null}
            {sku ? <section className={classes.sub_title}>{`SKU: ${sku}`}</section> : null}
          </section>
        </section>
        <section className={classes.price_block}>
          {price ? <section className={classes.price}>{`${actualPrice}`}</section> : null}
          {hasDiscount ? <section className={classes.actual_price}>{`${price}`}</section> : null}
        </section>
        {quantity && <section>{`x${quantity}`}</section>}

      </section>
      {selectedQuantity
        ? (
          <section className={classes.remark}>
            <section className={classes.remark_header}>
              <section>
                <span className={classes.bold}>Items damaged: </span>
                {selectedQuantity}
              </section>

              <section className={classes.remark_link} onClick={() => onClick(item)}>Edit</section>
            </section>
            {!!files.length && (
              <section className={classes.photos}>
                <span className={classes.bold}>Photos:&nbsp;</span>
                <span style={{ wordBreak: 'break-word' }}>{files.join('; ')}</span>
              </section>
            )}

            {comment && (
              <section className={classes.additional}>
                <span className={classes.bold}>Additional comments: </span>
                {comment}
              </section>
            )}
          </section>
        )

        : null}
    </section>
  );
}
